import { SET_HEADER_INFO } from "../mutation-types";

export default {
  [SET_HEADER_INFO]: ({ commit }) => {
    commit(SET_HEADER_INFO);
  }
};
